<template>
  <div>
    <div>
      <div class="d-flex justify-content-between mt-1 fs-3 fw-semibold">
        <i class="fa-solid fa-chevron-left pointer" :style="{ 'visibility': showReinvites ? '' : 'hidden'}" @click="showReinvites = !showReinvites"></i>
        <span v-if="!showReinvites && !showHistory">{{ $t('network.member.invitationDetails') }}</span>
        <span v-if="showReinvites || showHistory">Invite history</span>
        <i class="fa-solid fa-xmark pointer" @click="$emit('closeInviteModal')"></i>
      </div>
      <hr v-if="!showReinvites && !showHistory" />
      <div v-if="!showReinvites && !showHistory" class="d-flex justify-content-between mx-3">
        <span v-if="invite.name">{{ invite.name }}</span>
        <span>{{ invite.email }}</span>
        <span v-html="showInviteStatus(invite)"></span>
        <span>{{ invite.is_admin ? 'Admin' : 'Member' }}</span>
        <span>{{ getCreatedAtDate(invite.created_at) }}</span>
        <span v-if="history && invite.reinvites && !showReinvites" @click="showReinvites = !showReinvites">
          <i class="fa-solid fa-rectangle-history-circle-user text-primary pointer"></i>
        </span>
      </div>
      <hr />

      <div v-if="!showReinvites && !showHistory" class="card pt-1 px-5" style="border: unset;">
        <div v-if="((invite.accepted || invite.declined) && invite.message) || (!invite.accepted && !invite.declined)"
        class="card-header d-flex justify-content-between" style="background: #C8C6C6;">
          <span>{{ $t('invite-message') }}</span>
          <i v-if="!invite.accepted && !invite.declined" class="fas fa-pen-to-square text-primary mt-1 me-n2"></i>
        </div>
        <div class="card-body text-center p-0">
          <textarea
            v-if="((invite.accepted || invite.declined) && invite.message) || (!invite.accepted && !invite.declined)"
            id="invite_message"
            v-model="invite.message"
            data-test="invite_message"
            :placeholder="$t('network.member.newMessage')"
            class="form-control mb-4"
            style="border-radius: 0 0 0.75rem 0.75rem !important;"
            rows="5"
            max-rows="8"
            :disabled="invite.accepted || invite.declined"
          ></textarea>

          <button v-if="!invite.accepted && !invite.declined" id="resend_invitation" data-test="resend_invitation"
          :disabled="busy" class="btn btn-primary" @click="resendMemberInvitation">
            {{ $t('resend-invitation') }}
            <i v-if="busy" class="fas fa-spinner fa-spin"></i>
          </button>
        </div>
      </div>

      <div v-if="showReinvites || showHistory">
        <div v-if="history && invite.reinvites > 0 && !busy">
          <table class="table table-responsive text-center">
            <thead>
              <tr>
                <th>{{ $t('sent-by') }}</th>
                <th style="width: 125px;">{{ $t('network.meeting.when') }}</th>
                <th>{{ $t('network.member.message') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="reinvite in sortedArray(history, 'desc')" :key="reinvite.id">
                <td>{{ reinvite.creator.first_name }} {{ reinvite.creator.last_name }} ({{ reinvite.creator.email }})</td>
                <td>{{ utcToLocal(reinvite.created_at) }}</td>
                <td>{{ reinvite.message }}</td>
              </tr>
              <tr>
                <td>{{ invite.invited_by_name }} ({{ invite.invited_by_email }})</td>
                <td>{{ utcToLocal(invite.created_at) }}</td>
                <td>{{ invite.message }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="invite.reinvites == 0 && !busy">
          <table class="table table-responsive text-center">
            <thead>
              <tr>
                <th>{{ $t('sent-by') }}</th>
                <th style="width: 125px;">{{ $t('network.meeting.when') }}</th>
                <th>{{ $t('network.member.message') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ invite.invited_by_name }} ({{ invite.invited_by_email }})</td>
                <td>{{ utcToLocal(invite.created_at) }}</td>
                <td>{{ invite.message }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="history && busy" class="text-center mt-2">
          <lottie-player
            autoplay
            loop
	          speed="2.5"
            src="/img/animations/custom_loader.json"
            style="height: 80px;"
            >
          </lottie-player>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import orderBy from 'lodash/orderBy';

export default {
  props: {
    invite: {
      type: Object,
      default: null,
    },
    network_slug: {
      type: String,
      default: null,
    },
    showHistory: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { 
      busy: false,
      history: [],
      showReinvites: false,
    };
  },
  computed: {
    invite_link() {
      return window.location.protocol + '//' + window.location.host + '/invitation/' + this.invite.token;
    },
  },
  mounted() {
    this.fetchResends();
  },
  methods: {
    utcToLocal: function (dt) {
      return moment.utc(dt).local().format('MMM D, YYYY') + '\n' + moment.utc(dt).local().format('hh:mm');
    },
    sortedArray(array, order) {
      return orderBy(array, 'created_at', order);
    },
    getCreatedAtDate(date) {
      return moment.utc(date).local().format('MMM D, YYYY');
    },
    resendMemberInvitation() {
      this.busy = true;
      this.$http
        .post('networks/' + this.network_slug + '/members/resend-invite/' + this.invite.id, {
          inviteMessage: this.invite.message,
        })
        .then(() => {
          this.busy = false;
          this.$swal.fire({
              icon: 'success',
              title: 'Invitation re-sent succesfully to ' + this.invite.email,
              showCancelButton: false,
            }).then(() => {
              this.$emit('closeInviteModal');
            });
            //this.$bvModal.msgBoxOk(this.$t('network.member.invitationHasSent') + '.');
        })
        .catch(() => (this.busy = false));
    },
    showInviteStatus(invite){
      if (invite.accepted) {
        return '<span class="text-success">Accepted<span>';
      } else if (invite.declined) {
        return '<span class="text-danger">Declined<span>';
      } else {
        return '<span class="text-warning">Pending<span>';
      }
    },
    fetchResends() {
      this.busy = true;
      this.$http
        .get('networks/' + this.network_slug + '/members/get-resends-for-invite/' + this.invite.id)
        .then(resp => {
          this.busy = false;
          this.history = resp.data;
        })
        .catch(() => (this.busy = false));
    },
  },
};
</script>